import { MONITOR_ENV, ENV } from "@/constants/env";
const HOTJAR_TRACKING_CODE = {
  prod: "2418590", // dver.co.kr
  qa: "",
  dev: "2418880", // dver.link
};

class Hotjar {
  constructor() {
    (function (h, o, t, j, a, r) {
      h.hj =
        h.hj ||
        function () {
          (h.hj.q = h.hj.q || []).push(arguments);
        };
      h._hjSettings = {
        hjid: HOTJAR_TRACKING_CODE[ENV], // Hotjar ID
        hjsv: 6, // Hotjar Snippet Version
      };
      a = o.getElementsByTagName("head")[0];
      r = o.createElement("script");
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
  }
}

export default function setup() {
  if (!MONITOR_ENV || ENV === "qa") return;
  new Hotjar();
}
